import styled from 'styled-components'
import React from 'react'
import colors from '../styles/colors'
import ContentWidth from './ContentWidth'
import media from '../styles/media'
import GlobalButton from './buttons/GlobalButton'

const HighlightedCTA = ({ content }) => {
  return (
      <ContentWidth>
        <CTAContainer>
          <TextContainer dangerouslySetInnerHTML={{ __html:content.bodyCopy }} />
          <GlobalButton fill href={content.ctaLink}>
            {content.ctaText}
          </GlobalButton>
        </CTAContainer>
      </ContentWidth>
  )
}

const CTAContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 15.417vw;

    ${media.fullWidth} {
      gap: 222px;
    }
    
    ${media.tablet} {
    
    }
    
    ${media.mobile} {
      justify-content: center;
    }
`
const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    text-align: left;
    color: white;
    gap: 1.111vw;

    ${media.fullWidth} {
      gap: 16px;
    }
    
    ${media.tablet} {
    
    }
    
    ${media.mobile} {
      text-align: center;
      width: 90%;
    }
    
    h2 {
      ${media.desktop} {
        font-size: 2.778vw;
      }

      ${media.fullWidth} {
        font-size: 40px;
      }
      
      ${media.tablet} {
      
      }
      
      ${media.mobile} {
        font-size: 8.346vw;
      }
    }

    h4 {
      ${media.desktop} {
        font-size: 2.083vw;
      }

      ${media.fullWidth} {
        font-size: 30px;
      }
      
      ${media.tablet} {
      
      }
      
      ${media.mobile} {
        font-size: 6.009vw;
      }
    }
`
export default HighlightedCTA
